'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { syncUserAction } from '@/app/actions/sync-user';

export function UserSync() {
  const { isSignedIn, isLoaded } = useUser();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      syncUserAction();
    }
  }, [isLoaded, isSignedIn]);

  return null;
}
